module.exports = __webpack_public_path__ + "img/05.9613a0e1.png";